import axios from "axios";
import React from "react";
import { ButtonGroup, Dropdown, Table, DropdownButton } from "react-bootstrap";
const Users = ({ users }) => {
  return (
    <>
      <h3 className="text-center">
        Users : <span className="text-info"> {users?.length}</span>
      </h3>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Email</th>
            <th>Username</th>
            <th>Role</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user, i) => {
            return (
              <tr key={user._id}>
                <td>{i + 1}</td>
                <td>{user?.name}</td>
                <td>{user?.email}</td>
                <td>{user?.userName}</td>
                <td>{user?.role}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
};

export default Users;
